// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"component-divider-vertical"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M18 3H6V8H18V3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M18 16H6V21H18V16Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M18 3H6V8H18V3Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M18 16H6V21H18V16Z","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 12L21 12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-component-divider-vertical')
export default class ComponentDividerVerticalIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'component-divider-vertical',
    }
  }
}
